import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_PROCESS_NEW_RECORD, GET_PROCESS_NEW_RECORD} from '../actions';
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

import {
    createProcessNewRecordSuccess,
    createProcessNewRecordError,
    getProcessNewRecordSuccess,
    getProcessNewRecordError
} from './actions';

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createProcessNewRecordAsync = async (newRecord, payload) => {

  try{
    if (newRecord.processId > 0)
    {
      const responseObject = await centralApiAxios.put("processes?id="+ newRecord.processId, newRecord,getActivityHeadersUpdated(payload));

      return {
      newsItem: responseObject.data,
      processId: responseObject.data.processId,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.processId > 0),
      message: ""
      };
    }
    else{
      const responseObject = await centralApiAxios.post("processes", newRecord,getActivityHeadersUpdated(payload));

      return {
      newsItem: responseObject.data,
      processId: responseObject.data.processId,
      trashed : newRecord.trashed,
      isProcessItemCreate: !(newRecord.processId > 0),
      message: ""
      };
    }
  }
  catch (err) {
    alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createProcessNewRecord({ payload }) {
     const { history } = payload;
    try {
      const resultReturned = yield call(createProcessNewRecordAsync, payload.newRecord.processRecord, payload);
      if (!resultReturned.message) {
        yield put(createProcessNewRecordSuccess(resultReturned));
        if (payload.newRecord.processRecord.trashed === true) {
        history.push("/app/RecordListing/Processes");
        window.location.reload();
      }
      if (resultReturned.isProcessItemCreate) {
        history.push("/app/process-overview/"+ resultReturned.processId  +"/" + payload.newRecord.processRecord.processCode);
        window.location.reload();
      }
      else{
        window.location.reload();
      }
        
      } else {
        yield put(createProcessNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createProcessNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getProcessNewRecordAsync = async (payload) => {
  
  if (payload.processId == 0)
  {
    return {
      processRecord: undefined,
      processId: 0,
      message: ""
    };
  }
  try{
    const responseObject = await centralApiAxios.get(`/processes/${  payload.processId}?lcid=1033`,getActivityHeadersUpdated(payload));
    return {
    processRecord: responseObject.data,
    processId: responseObject.data.processId,
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getProcessNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(getProcessNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(getProcessNewRecordSuccess(resultReturned));
      } else {
        yield put(getProcessNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getProcessNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_PROCESS_NEW_RECORD, createProcessNewRecord);
}
// eslint-disable-next-line
export function* watchGetProcessNewRecord(newRecord) {
  yield takeEvery(GET_PROCESS_NEW_RECORD, getProcessNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetProcessNewRecord),
        fork(watchCreateRecords)
    ]);
}
